// extracted by mini-css-extract-plugin
export var equalColumn = "_in-0";